// Données statiques de la page vitrine FTPE Outremer (constantes + logo).
import { Shield, Users, FileText, TrendingUp, Landmark, Vote, HandHeart, Scale, Building2, UserCheck, Briefcase, Globe, Network, FileSignature, CreditCard, BadgeCheck, ClipboardCheck, BookOpen } from 'lucide-react';

export const FTPE_LOGO = "https://customer-assets.emergentagent.com/job_80d9c916-7281-4428-9c84-a6e0cd256c92/artifacts/ojac2aim_logo%20ftpe%20outremer%20dans%20fond%20blanc.png";

export const TERRITOIRES = [
  // DROM - Départements et Régions d'Outre-Mer
  { nom: "Guadeloupe", type: "DROM", code: "971" },
  { nom: "Martinique", type: "DROM", code: "972" },
  { nom: "Guyane", type: "DROM", code: "973" },
  { nom: "La Réunion", type: "DROM", code: "974" },
  { nom: "Mayotte", type: "DROM", code: "976" },
  // COM - Collectivités d'Outre-Mer
  { nom: "Saint-Pierre-et-Miquelon", type: "COM", code: "975" },
  { nom: "Saint-Barthélemy", type: "COM", code: "977" },
  { nom: "Saint-Martin", type: "COM", code: "978" },
  { nom: "Wallis-et-Futuna", type: "COM", code: "986" },
  { nom: "Polynésie française", type: "COM", code: "987" },
  // PTOM - Pays et Territoires d'Outre-Mer
  { nom: "Nouvelle-Calédonie", type: "PTOM", code: "988" },
  { nom: "TAAF", type: "PTOM", code: "984" },
];

export const MISSIONS = [
  {
    icon: Shield,
    text: "Représenter et défendre les intérêts collectifs des TPE ultramarines"
  },
  {
    icon: Users,
    text: "Participer aux négociations collectives et instances paritaires"
  },
  {
    icon: BookOpen,
    text: "Informer et accompagner les employeurs sur les enjeux sociaux, juridiques et économiques"
  },
  {
    icon: TrendingUp,
    text: "Favoriser le développement durable, l'emploi et la pérennité des entreprises ultramarines"
  }
];

// Valeurs FTPE
export const VALEURS = [
  { 
    icon: Landmark, 
    label: "Indépendance", 
    description: "Liberté d'action et de positionnement" 
  },
  { 
    icon: Vote, 
    label: "Équité", 
    description: "Un membre = une voix" 
  },
  { 
    icon: HandHeart, 
    label: "Solidarité ultramarine", 
    description: "Prise en compte des réalités locales" 
  },
  { 
    icon: Scale, 
    label: "Éthique et transparence", 
    description: "Gouvernance responsable" 
  }
];

// Publics cibles
export const PUBLICS_CIBLES = [
  { icon: Building2, label: "Très Petites Entreprises (TPE)" },
  { icon: UserCheck, label: "Employeurs individuels" },
  { icon: Briefcase, label: "PME de proximité" },
  { icon: Globe, label: "Structures employeuses ultramarines" },
  { icon: Network, label: "Organisations représentant des employeurs" }
];

// Avantages adhésion
export const AVANTAGES_ADHESION = [
  "Être représenté collectivement auprès des institutions",
  "Accéder à une information fiable et adaptée aux Outre-mer",
  "Participer à la vie syndicale et aux décisions",
  "Intégrer un réseau d'entrepreneurs engagés"
];

// Étapes adhésion
export const ETAPES_ADHESION = [
  { 
    numero: 1, 
    icon: FileText, 
    titre: "Consultation", 
    description: "Consultation du document d'adhésion" 
  },
  { 
    numero: 2, 
    icon: FileSignature, 
    titre: "Signature", 
    description: "Signature électronique sécurisée" 
  },
  { 
    numero: 3, 
    icon: CreditCard, 
    titre: "Paiement", 
    description: "Paiement de la cotisation" 
  },
  { 
    numero: 4, 
    icon: BadgeCheck, 
    titre: "Attestation", 
    description: "Réception de l'attestation d'adhésion" 
  }
];

// Documents de référence
export const DOCUMENTS_REFERENCE = [
  { titre: "Statuts de la FTPE Outremer", icon: FileText },
  { titre: "Règlement intérieur", icon: ClipboardCheck },
  { titre: "Charte d'éthique", icon: Scale }
];
